import { ModuleFE_Variable } from './ModuleFE_Variable.js';
export const ModulePackFE_Variable = [ModuleFE_Variable];
//# sourceMappingURL=module-pack.js.map